import { createFileRoute } from "@tanstack/react-router";
import { PeopleIcon } from "../../components/icons/sidebar-icons";
import { ModulePlaceholder } from "../../components/modules/module-placeholder";

export const Route = createFileRoute("/_app/volunteers")({
	component: () => <ModulePlaceholder messageKey="volunteers.message" icon={PeopleIcon} />,
});
